import { ReactNode, useMemo } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import PageSeo from '@framework/seo/PageSeo';
import config from '@creditflowresearch/config';
import ScrollBodyBackground from '@framework/ui/Templates/ScrollBodyBackground';
import PopupBackButton from '@/creditflowresearch/ui/components/ActiveCalendar/PopupBackButton';
import Footer from '@/creditflowresearch/ui/common/components/Footer';
import Header from '@/creditflowresearch/ui/common/components/organisms/Header';
import URL from '@/creditflowresearch/Router/urlConstants';
import BreadcrumbsContextProvider from '@/creditflowresearch/ui/common/components/header/Breadcrumbs/BreadcrumbsContext';
import StaticPagesContextProvider from '@/creditflowresearch/ui/components/staticPages/StaticTemplate/StaticPagesContext';
import BookDemoPageWrapper from '@/creditflowresearch/ui/common/components/BookDemoPageWrapper/BookDemoPageWrapper';
import LayoutTemplate from '@/creditflowresearch/ui/common/components/templates/LayoutTemplate';
import cfrbUrl from '@/creditflowresearch/infrastructure/url';
import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import { IFooter } from '@/creditflowresearch/domain/vo/IFooter';
import { useMetaTagsContext } from '@/creditflowresearch/application/MetaTags/MetaTagsContext';

interface ILayoutProps {
  children: ReactNode,
  breadcrumbs?: IBreadcrumb[] | { hasError: boolean },
  footerConfig?: IFooter,
}

const CFRLayout = ({
  children,
  breadcrumbs,
  footerConfig,
}: ILayoutProps) => {
  const { pathname, asPath } = useRouter();
  const { state: metaTags } = useMetaTagsContext();
  const isOnStaticPage = useMemo(() => URL.STATIC_PAGES_LIST.indexOf(pathname) !== -1, [pathname]);

  return (
    <BookDemoPageWrapper>
      { !isOnStaticPage && (<PageSeo { ...metaTags } />) }
      <Head>
        <link rel="canonical" href={ cfrbUrl.getUrl(asPath) } />
      </Head>
      <ScrollBodyBackground tenant={ config.code } />
      <PopupBackButton />
      <StaticPagesContextProvider>
        <BreadcrumbsContextProvider breadcrumbs={ breadcrumbs }>
          <LayoutTemplate
            HeaderComponent={ <Header /> }
            FooterComponent={ <Footer config={ footerConfig } /> }
          >
            { children }
          </LayoutTemplate>
        </BreadcrumbsContextProvider>
      </StaticPagesContextProvider>
    </BookDemoPageWrapper>
  );
};

export default CFRLayout;
